<template>
  <div :class="{loader: true, fadeout: !estaCarregando}">
    <img 
      src="static/imagens/logos/logo_santri.svg" 
      style="width: 15rem; margin-top: 15%" 
      class="w3-margin-bottom">
    
    <br>
    
    <div>
      <i class="fas fa-spinner fa-pulse"></i>
    </div>
    
    <br>
    
    <span>Carregando...</span>
  </div>
</template>

<script>
  export default {
    name: "Carregando",
    props: ["estaCarregando"]
  }
</script>

<style>
  .loader {
    background-color: #ffffff;
    bottom: 0;
    color: #8d1007;
    display: block;
    font-size: 32px;
    left: 0;
    overflow: hidden;
    padding-top: 10vh;
    position: fixed;
    right: 0;
    text-align: center;
    top: 0;
  }

  .fadeout {
    animation: fadeout 2s forwards;
  }

  @keyframes fadeout {
    to {
      opacity: 0;
      visibility: hidden;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Carregando.vue